import { Dispatch, SetStateAction, useRef, useEffect, useState } from "react";

import { useLocation } from "react-router";

import {
    ChevronDown,
    useAnalytics,
    useAnalyticsAttributes
} from "../../../components";
import { UiHeaderNavTabModel, UiLinkModel } from "../../../models";

import { TabGroup, Tab, Link, Underline } from "./Tabs.styles";

type TabsProps = {
    tabs: readonly (UiHeaderNavTabModel | UiLinkModel)[];
    activeTab?: number;
    setActiveTab: Dispatch<SetStateAction<number | undefined>>;
};

const Tabs = ({ tabs, activeTab, setActiveTab }: TabsProps) => {
    const location = useLocation();
    const { sendTrackEvent } = useAnalytics();
    const analyticsAttributes = useAnalyticsAttributes();
    const activeTabRef = useRef<HTMLButtonElement>(null);
    const [activeTabStyle, setActiveTabStyle] = useState<{
        left?: number;
        width: number;
    }>({ width: 0 });

    useEffect(() => {
        if (activeTabRef.current) {
            setActiveTabStyle({
                left: activeTabRef.current.offsetLeft + 16,
                width: activeTabRef.current.clientWidth - 32
            });
        } else if (activeTabStyle && activeTabStyle.left) {
            setActiveTabStyle({
                left: activeTabStyle.left,
                width: 0
            });
            setTimeout(() => {
                setActiveTabStyle({ width: 0 });
            }, 300);
        }
    }, [activeTab, activeTabRef, activeTabStyle]);

    return (
        <TabGroup>
            {tabs?.map((tab, index) =>
                tab.type === "uiHeaderNavTab" ? (
                    <Tab
                        aria-expanded={activeTab === index}
                        data-active={activeTab === index}
                        data-testid="bignav-tab"
                        key={index}
                        onClick={(e) => {
                            if (activeTab === index) {
                                setActiveTab(undefined);
                            } else {
                                sendTrackEvent("clickedGlobalNavTab", {
                                    ...analyticsAttributes,
                                    event: "clicked",
                                    eventComponent: "globalNavTab",
                                    label: tab.content.title,
                                    labelEnglish: tab.content.entryTitle,
                                    uuid: tab.id
                                });
                                setActiveTab(index);
                            }
                            e.stopPropagation();
                        }}
                        ref={activeTab === index ? activeTabRef : null}
                    >
                        {tab.content.title}
                        <ChevronDown />
                    </Tab>
                ) : tab.type === "uiLink" ? (
                    <Link
                        aria-current={
                            location?.pathname === tab.content.url
                                ? "page"
                                : undefined
                        }
                        href={tab.content.url}
                        key={index}
                        onClick={() =>
                            sendTrackEvent("clickedGlobalNavLink", {
                                ...analyticsAttributes,
                                event: "clicked",
                                eventComponent: "globalNavLink",
                                label: tab.content.text,
                                labelEnglish: tab.content.entryTitle,
                                href: tab.content.url,
                                uuid: tab.id
                            })
                        }
                    >
                        {tab.content.text}
                    </Link>
                ) : null
            )}
            <Underline style={activeTabStyle} />
        </TabGroup>
    );
};

export default Tabs;
